/* tabs.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import React, { useContext } from "react";
import theme from "../theme";
var _21 = "._4t3it4lq{height:calc(100% - 3pc)}";
var _20 = "._1hvw1o36:focus{outline-width:medium}";
var _19 = "._49pcglyw:focus{outline-style:none}";
var _18 = "._nt751r31:focus{outline-color:currentColor}";
var _17 = "._irr33ch5:hover{background-color:rgba(205,214,244,.05)}";
var _16 = "._d0altlke:hover{cursor:pointer}";
var _15 = "._n7zl13lm{border-bottom:var(--_1deexx)}";
var _14 = "._uiztglyw{-webkit-user-select:none;-moz-user-select:none;user-select:none}";
var _13 = "._vchhusvi{box-sizing:border-box}";
var _12 = "._19bv1tcg{padding-left:24px}";
var _11 = "._n3tddlk8{padding-bottom:14px}";
var _10 = "._u5f31tcg{padding-right:24px}";
var _9 = "._ca0q7vkz{padding-top:1pc}";
var _8 = "._1wybw1gv{font-size:13px}";
var _7 = "._1p1dangw{text-transform:uppercase}";
var _6 = "._syaz5y2n{color:#cdd6f4}";
var _5 = "._1bsb1osq{width:100%}";
var _4 = "._4t3i1osq{height:100%}";
var _3 = "._n7zl14jc{border-bottom:1px solid rgba(203,166,247,.2)}";
var _2 = "._qtt8glyw{list-style:none}";
var _ = "._1e0c1txw{display:flex}";
var TabsContextProvider = /*#__PURE__*/React.createContext({
  selectedIndex: "state",
  // eslint-disable-next-line
  onSelect: function onSelect(_index) {}
});
export var TabList = function TabList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement("div", {
    "data-test-id": "__prosemirror_devtools_tabs_buttons_container__",
    className: ax(["_1e0c1txw _qtt8glyw _n7zl14jc"])
  }, children));
};
var TabsStyled = function TabsStyled(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _5]), /*#__PURE__*/React.createElement("div", {
    "data-test-id": "__prosemirror_devtools_tabs_container__",
    className: ax(["_4t3i1osq _1bsb1osq"])
  }, children));
};
var TabStyled = function TabStyled(_ref3) {
  var children = _ref3.children,
    isSelected = _ref3.isSelected,
    onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20]), /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: ax(["_syaz5y2n _1p1dangw _1wybw1gv _ca0q7vkz _u5f31tcg _n3tddlk8 _19bv1tcg _vchhusvi _uiztglyw _n7zl13lm _d0altlke _irr33ch5 _nt751r31 _49pcglyw _1hvw1o36"]),
    style: {
      "--_1deexx": ix(isSelected ? "2px solid ".concat(theme.main) : "none")
    }
  }, children));
};
export function Tab(_ref4) {
  var index = _ref4.index,
    children = _ref4.children;
  var tabs = useContext(TabsContextProvider);
  return /*#__PURE__*/React.createElement(TabStyled, {
    isSelected: index === tabs.selectedIndex,
    onClick: function onClick() {
      return tabs.onSelect(index);
    }
  }, children);
}
export function TabPanel(props) {
  var tabs = useContext(TabsContextProvider);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_5, _21, _13]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1bsb1osq _4t3it4lq _vchhusvi"])
  }, props.children({
    index: tabs.selectedIndex
  })));
}
export function Tabs(props) {
  return /*#__PURE__*/React.createElement(TabsContextProvider.Provider, {
    value: {
      onSelect: props.onSelect,
      selectedIndex: props.selectedIndex
    }
  }, /*#__PURE__*/React.createElement(TabsStyled, null, props.children));
}